export const isCompliteNumberRegex = (value) => !/[0-9]+(\.|(\.\d*0+))$/.test(value);
